import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExportCsvModalComponent} from "@shared/export-csv-modal/export-csv-modal.component";

@Component({
  selector: 'app-export-csv',
  templateUrl: './export-csv.component.html',
  styleUrls: ['./export-csv.component.scss']
})
export class ExportCsvComponent implements OnInit {
  @ViewChild('exportCSV', {static: true}) exportCSV: ExportCsvModalComponent | any;
  @Input() path: any;
  @Input() params: any;
  @Input() disabled: any;

  constructor() {
  }

  ngOnInit() {
  }

  public openExportModal() {
    this.exportCSV.exportPath = this.path;
    this.exportCSV.exportParams = this.params;
    this.exportCSV.open();
  }
}
